import * as R from "ramda";
const parseTreeResultsAsList = ({ lists, listValues }) => (sdmxJson) => {
  const getNodesData = ({ parentId, parentCode, topParentId }) => R.reduce((acc, node) => {
    const label = R.prop("name")(node);
    const code = R.prop("id", node);
    const agencyId = R.prop("agencyID", node);
    const version = R.prop("version", node);
    const hierarchicalCode = R.when(
      R.always(parentCode && parentId !== topParentId),
      R.concat(`${parentCode}.`)
    )(code);
    const id = R.when(
      R.always(parentId),
      R.always(`${parentId}.${code}`)
    )(`${agencyId}:${code}(${version})`);
    const nodeData = R.pipe(
      R.when(R.always(parentId), R.assoc("parentId", parentId)),
      R.when(R.always(topParentId), R.assoc("topParentId", topParentId))
    )({ agencyId, code, hierarchicalCode, id, label, version });
    const childNodes = getNodesData({
      parentId: id,
      parentCode: hierarchicalCode,
      topParentId: R.when(R.isNil, R.always(id))(topParentId)
    })(R.propOr([], listValues, node));
    return R.pipe(R.assoc(id, nodeData), R.mergeRight(childNodes))(acc);
  }, {});
  return R.pipe(R.pathOr([], ["data", lists]), getNodesData({}))(sdmxJson);
};
export {
  parseTreeResultsAsList
};
